import { render } from "./Badges.vue?vue&type=template&id=772ae97d"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__